/** Rótulo de catálogo por id. Se a chave não existir, mantém o texto original. */
export function catalogLabel(t, prefix, id, fallback = '') {
  if (id == null || id === '') return fallback;
  const key = `${prefix}.${id}`;
  const value = t(key);
  return value === key ? (fallback || String(id)) : value;
}

export function translate(messages, key, vars) {
  const value = String(key)
    .split('.')
    .reduce((acc, part) => (acc == null ? undefined : acc[part]), messages);

  if (typeof value !== 'string') return key;

  if (!vars) return value;

  return value.replace(/\{(\w+)\}/g, (_, name) => (
    vars[name] == null ? '' : String(vars[name])
  ));
}
